import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsAuth, clearAuthAndRedirect } from '@/entities/Auth';
import { AccountType, getMyProfile } from '@/entities/Profile';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { routerPath } from '@/shared/config/router';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedAccountTypes?: AccountType[];
}

export const ProtectedRoute = ({ children, allowedAccountTypes }: ProtectedRouteProps) => {
  const isAuth = useSelector(getIsAuth);
  const user = useSelector(getMyProfile);
  const accessToken = LocalStorageService.getAccessTokenFromAnyStorage();
  const location = useLocation();

  useEffect(() => {
    if (!accessToken && !isAuth) {
      clearAuthAndRedirect(routerPath.login);
    }
  }, [accessToken, isAuth]);

  // Если не авторизован - редирект на логин
  if (!isAuth && !accessToken) {
    return <Navigate to={routerPath.login} state={{ from: location.pathname }} replace />;
  }

  if (allowedAccountTypes && allowedAccountTypes.length > 0 && user?.accountType) {
    if (!allowedAccountTypes.includes(user.accountType)) {
      // Редирект на главную страницу, если роль не подходит
      return <Navigate to={routerPath.main} replace />;
    }
  }

  return <>{children}</>;
};
